<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15661.900915679957!2d77.0528094!3d11.0779156!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x19fd2fde6b9dfd37!2sRenown%20Energy%20%26%20Equipment%20Private%20Limited!5e0!3m2!1sen!2sin!4v1628933532220!5m2!1sen!2sin"
      style="border:0; display: block;"
      tabindex="0"
      width="100%"
    />
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMap',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
